import { render, staticRenderFns } from "./picker-shoptag.vue?vue&type=template&id=c1866dea"
import script from "./picker-shoptag.vue?vue&type=script&lang=js"
export * from "./picker-shoptag.vue?vue&type=script&lang=js"
import style0 from "./picker-shoptag.vue?vue&type=style&index=0&id=c1866dea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports